import React from "react";
type HandArrowProps = {
  className?: string;
};
export function HandArrow({
  className
}: HandArrowProps) {
  return <svg viewBox="0 0 80 40" fill="none" className={className} aria-hidden="true" data-id="element-27" data-mp="2btsz6054cw7h">
      <path d="M3 29c13-13 33-20 53-15.5 6.5 1.5 11.5 4 15.5 7.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-28" data-mp="26uy49ztvnh70" />
      <path d="M61.5 12.4l11 8.6-12.6 3.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-29" data-mp="2zkf3phfwzycq" />
    </svg>;
}